import { AccordionSummary } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
export const AccordionSummaryWithPadding = styled(AccordionSummary)({
  paddingLeft: 15,
  paddingRight: 15,
});
